import React from 'react';

const Loading=()=> (
<div className="ui active dimmer">
<div className="ui large text loader">Loading Your NetWork is Slow/Off</div>
</div>
);
export { Loading };


// WEBPACK FOOTER //
// ./src/components/common/Loading.js